import type { MoneyData } from '../../../../app/data/model';
import Price from '../../../../app/shared/components/Price';
import { Subtitle2Bold } from '../../../../app/shared/components/Typography/Subtitle';
import type { CartItemSubtotalTranslation } from '../../../localization/SiteTranslation';
import css from './CartItemSubtotal.css';

interface CartItemSubtotalProps {
  totalPrice: MoneyData;
  translation: CartItemSubtotalTranslation;
}

export const CartItemSubtotal = ({ totalPrice, translation }: CartItemSubtotalProps) => (
  <div className={css.shoppingCartDetailsSubtotal}>
    <Subtitle2Bold>
      {translation.subtotalText} <span className={css.shoppingCartDetailsVat}>{translation.exclValText}</span>
    </Subtitle2Bold>
    <Price className={css.shoppingCartDetailsTotalPrice} price={totalPrice} />
  </div>
);
